import { BaseModel } from '@/app/modules/base/BaseModel';

/**
 * @deprecated legacy
 */
export class Date extends BaseModel {
  constructor(readonly value: string, readonly format: string = 'DD.MM.YYYY HH:mm', readonly formattedValue?: string) {
    super();
  }
}
